import { render, staticRenderFns } from "./sidebar_workspace.vue?vue&type=template&id=582fdcf9&scoped=true&"
import script from "./sidebar_workspace.vue?vue&type=script&lang=js&"
export * from "./sidebar_workspace.vue?vue&type=script&lang=js&"
import style0 from "./sidebar_workspace.vue?vue&type=style&index=0&id=582fdcf9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582fdcf9",
  null
  
)

export default component.exports